import { render, staticRenderFns } from "./scanBind.vue?vue&type=template&id=235708fe&scoped=true&"
import script from "./scanBind.vue?vue&type=script&lang=js&"
export * from "./scanBind.vue?vue&type=script&lang=js&"
import style0 from "./scanBind.vue?vue&type=style&index=0&id=235708fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235708fe",
  null
  
)

export default component.exports